export default (data, symbol) => {
	return {
		action: 'draw-chart',
		chart: {
			backgroundColor: 'rgba(255, 255, 255, 0.0)'
		},
		series: [
			{
				name: symbol,
				data,
				color: '#FF6B01'
			}
		],
		legend: {
			enabled: true
		},
		navigator: {
			enabled: false
		},
		rangeSelector: {
			enabled: false,
			verticalAlign: 'bottom',
			x: 0,
			y: 0
		},
		xAxis: {
			gridLineWidth: 1,
			tickInterval: 1
		},
		yAxis: {
			gridLineWidth: 1,
			gridLineColor: '#FF6B01'
		},
		scrollbar: {
			enabled: false
		},
		stockTools: {
			gui: {
				enabled: false
			}
		}
	};
};
